export default "__VITE_ASSET__BTnP9q1z__"